// Курируемый вручную список направлений для блока подборок туров на главной странице.
// Порядок значим: запрос к API идёт с sorting: 'filter_slugs', поэтому регионы
// выводятся ровно в той последовательности, в которой перечислены здесь.
// Обновляется редакцией/маркетингом; чтобы изменить состав или порядок блока — правим этот массив.

// При создании апихи было требование бизнеса установить только конкретные регионы https://tripster.slack.com/archives/C04BTMXU11Q/p1785859804634619
export const TOURS_REGION_SLUGS = [
  'vietnam',
  'sri-lanka',
  'dombaj',
  'indonesia',
  'egypt',
  'kareliya',
  'thailand',
  'turkey',
  'china',
  'japan',
];
